export const STRATEGY_RESULT_CALLBACK = "JudgerResultCallBack"
export const STRATEGY_SUBMIT_LIST_BY_LAB_ID = "SubmitListByLabId"